import { render, staticRenderFns } from "./SystemMessageView.vue?vue&type=template&id=2051798b&scoped=true"
import script from "./SystemMessageView.vue?vue&type=script&lang=js"
export * from "./SystemMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2051798b",
  null
  
)

export default component.exports